import AdditionalVisitorsService from '@/services/AdditionalVisitorsService';
import moment from 'moment/moment';
import Vue from 'vue';

const initialState = () => ({
  visit: null,
  additionalVisitors: [],
});

export default {
  namespaced: true,
  state: {
    visit: null,
    additionalVisitors: [],
    visitorsFirstVisit: false,
  },
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, initialState());
    },
    SET_VISIT(state, visit) {
      state.visit = visit;
    },
    SET_ADDITIONAL_VISITORS(state, additionalVisitors) {
      state.additionalVisitors = additionalVisitors;
    },
    SET_VISITORS_FIRST_VISIT(state, value) {
      state.visitorsFirstVisit = value;
    },
  },
  actions: {
    resetState({ commit }) {
      commit('RESET_STATE');
    },
    setVisit({ commit }, visit) {
      commit('SET_VISIT', visit);
    },
    async getAdditionalVisitors({ commit }, id) {
      await AdditionalVisitorsService.getAdditionalVisitorsForSocialVisit(id).then(res => {
        let visitors = [...res.data];

        visitors = visitors.map(person => ({
          fullName: `${person.firstname} ${person.lastname}`,
          birthDateAndAge: `${moment(person.dob).format('DD/MM/YYYY')} (${moment(new Date()).diff(person.dob, 'years')})`,
          under18: parseInt(moment(new Date()).diff(person.dob, 'years'), 10) < 18,
          ...person,
        }));

        commit('SET_ADDITIONAL_VISITORS', visitors);

        return visitors;
      }).catch(() => {
        Vue.$toast.error('Something went wrong fetching the additional participants, please check your connection and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      });

      return null;
    },
  },
};
